import { Injectable} from '@angular/core';
import { FormGroup } from '@angular/forms';


@Injectable({
    providedIn: 'root'
})
export class FormValidator{

  constructor() {}

    public hasAtLeastOneValidator(form: FormGroup): boolean{
        let controls = form.controls;
        var hasOne = false;
        if(controls){
            hasOne = !!Object.keys(controls).find( key => controls[key].value);
        }
        return hasOne;
    }

    public isNumChar(input: KeyboardEvent): boolean{
        if(input.key === '0' || input.key === '1' || input.key === '2' || input.key === '3' || input.key === '4' || input.key === '5'
            || input.key === '6' || input.key === '7' || input.key === '8' || input.key === '9'){
            return true;
        }
        return false;
    } 
}
